import type { MetaFunction } from 'react-router'
import ProcessPage from '~/pages/ProcessPage.jsx'

export const meta: MetaFunction = () => [
  { title: 'Our Process | S.J.S. Technology' },
  {
    name: 'description',
    content:
      'How S.J.S. Technology works — from consultation and live demo to installation and 24/7 after-sales support. A simple, transparent process.',
  },
  { property: 'og:title', content: 'Our Process | S.J.S. Technology' },
  { property: 'og:url', content: 'https://sjstechnology.in/process' },
]

export default function Process() {
  return <ProcessPage />
}
